var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeaseDetail',{attrs:{"is-mobile":_vm.$q.screen.xs,"loading":_vm.leaseLoading,"lease":_vm.lease,"savings":_vm.savings},on:{"back":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }